import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f81db264&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f81db264&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=f81db264&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81db264",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\oywen\\niehao\\qft\\20260317\\vue-admin-template-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f81db264')) {
      api.createRecord('f81db264', component.options)
    } else {
      api.reload('f81db264', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f81db264&scoped=true", function () {
      api.rerender('f81db264', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channel/channelList/index.vue"
export default component.exports